<template>
  <div class="pt-4 pl-3">
    <span>
      <v-icon x-large>mdi-arrow-left-bold</v-icon> Please select a project!
    </span>
  </div>
</template>

<script>
import Intranet from "@/core/intranet";

export default {
  name: "WelcomeView",
  mounted() {

    if(Intranet.features().isFeatureActive("DFG_SURVEY"))
      this.$store.dispatch('dfg/loadMySurvey').then(() => {
        if (!this.$store.getters['dfg/isSubmittedForCurrentYear']) {
          this.$router.push({name: "dfg"})
        }
      })

  }
}
</script>

<style scoped>

</style>
